import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import tw from "twin.macro";
import { getAuth, onAuthStateChanged  } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../FireBaseConfig";
import iconBalance from "../../../images/icon/BalanceCard.svg";
import { useTranslation } from "react-i18next";

const Container = styled.div`
    ${tw`bg-white shadow-lg p-6 relative`}
    width: calc(100% - 40px);
    border-radius: 20px;
    min-height: 250px;
    margin-bottom: 16px;

    @media (max-width: 768px) {
        margin-left: 10px;
        width: calc(100% - 66px);
    }
`;

const GreenStrip = styled.div`
    ${tw`absolute top-0 left-0 w-full h-16 bg-green-1000 rounded-t-2xl`}
`;

const CircleIcon = styled.div`
    ${tw`w-20 h-20 bg-white rounded-full flex items-center justify-center absolute`}
    top: 14px;
    left: 46px;
`;

const CardHeader = styled.div`
    ${tw`flex flex-col items-center mb-4 relative`}
    margin-top: 32px;
`;

const BalanceText = styled.div`
    ${tw`font-extrabold text-xl sm:text-xl mt-2 ml-12 lg:text-xl text-center leading-tight`}
  
    padding-right: 20%;
    span {
        color: #0ABD19;
    }
    @media (max-width: 768px) {
        ${tw`w-full`}
        padding-left: 80%;
    }
`;

const CardContent = styled.div`
    ${tw`flex flex-col items-center`}
`;

const InputContainer = styled.div`
    ${tw`w-full flex items-center mt-4 mb-4`}
    @media (max-width: 768px) {
    ${tw`flex-col items-start`}
}
`;

const InputField = styled.div`
    ${tw`relative w-1/2 flex items-center`}
    @media (max-width: 768px) {
    ${tw`w-full mb-4`}
}
`;

const Input = styled.input`
    ${tw`w-full py-3 px-4 border-none focus:outline-none rounded-lg`}
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.12), inset 0 -1px 3px rgba(0, 0, 0, 0.12);
    background: #ffffff;
    padding-right: 2.5rem;
`;

const CurrencySymbol = styled.div`
    right: 20px;
    ${tw`absolute text-gray-500`}
`;

const Button = styled.button`
    ${tw`bg-green-500 text-white font-bold py-3 px-6 rounded-2xl ml-8 focus:outline-none transition duration-300`}
    border: none;
    background-color: #0ABD19;
    &:hover, &:focus {
        transform: scale(1.1);
    }
    @media (max-width: 768px) {
        ${tw`w-full ml-0`}
    }
`;

const Description = styled.div`
    ${tw`mt-4 text-base xl:text-lg my-2 lg:my-4 text-gray-700`}
    text-align: left;
    width: 100%;
    line-height: 1.2;
    margin-left: 1rem;
    margin-right: 1rem;
    @media (max-width: 768px) {
        ${tw`text-xs`}
    }
`;

const BalanceCard = () => {
    const [amount, setAmount] = useState("");
    const [balance, setBalance] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const q = query(
                    collection(db, "balances"),
                    where("userId", "==", user.uid)
                );
                const querySnapshot = await getDocs(q);
                if (!querySnapshot.empty) {
                    const docSnap = querySnapshot.docs[0];
                    setBalance(docSnap.data().balance);
                } else {
                    setBalance(0.00);
                }
            }
        });

        return () => unsubscribe();
    }, []);

    const handleInputChange = (e) => {
        setAmount(e.target.value);
    };

    const handleTopUpClick = () => {
        const numericAmount = parseFloat(amount);

        if (!numericAmount || numericAmount <= 0 || isNaN(numericAmount)) {
            alert('Пожалуйста, введите корректную сумму (больше 0)');
            return;
        }

        if (numericAmount < 100) {
            alert('Минимальная сумма пополнения: 100 ₸');
            return;
        }

        navigate('/PaymentForm', { state: { amount: numericAmount } });
    };
    const { t } = useTranslation();
    return (
        <Container>
            <GreenStrip />
            <CircleIcon>
                <img src={iconBalance} alt="Balance Icon" />
            </CircleIcon>
            <CardHeader>
                <BalanceText>
                    {t("balance.title")}{" "}
                    {balance !== null ? <span>{balance.toFixed(2)} ₸</span> : <span>...</span>}
                </BalanceText>


            </CardHeader>
            <CardContent>
                <div style={{ color: '#999999', alignSelf: 'flex-start', marginTop: '1rem' }}>
                    {t("balance.enterAmount")}
                </div>
                <InputContainer>
                    <InputField>
                        <Input
                            type="number"
                            value={amount}
                            onChange={handleInputChange}
                            min="100"
                            placeholder="100"
                        />
                        <CurrencySymbol>₸</CurrencySymbol>
                    </InputField>
                    <Button onClick={handleTopUpClick}>{t("balance.topUpButton")}</Button>
                </InputContainer>
                <Description>
                    {t("balance.note")}
                </Description>
            </CardContent>
        </Container>
    );
};

export default BalanceCard;
